module.exports = __webpack_public_path__ + "static/img/6.16b84fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/6.png
// module id = kr9o
// module chunks = 0